import axios from "axios";
import { URLS } from "./URLS";

export default async function postDistribute(payload) {
  let data = null;
  await axios
    .post(`${URLS.krakenURL}cabinet/debt/terminal/distribute`, payload)
    .then((res) => {
      data = res.data;
    })
    .catch(function (error) {
      console.log("postDistribute error", error);
      data = "error";
    });
  return data;
}
